import { useRouteMatch, Switch, Route } from "react-router";
import EmploymentStatus from "./EmploymentStatus";

const EmploymentStatusRoot = (props) => {
  let { path } = useRouteMatch();

  return (
    <>
      <Switch>
        <Route path={`${path}`} component={EmploymentStatus} />
      </Switch>
    </>
  );
};

export default EmploymentStatusRoot;
